import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {PaymentScheduleStatusEditForm} from "./PaymentScheduleStatusEditForm";

export const PaymentScheduleStatusEdit = (props: EditProps) => {
    return (
        <DefaultEdit {...props}>
            <PaymentScheduleStatusEditForm />
        </DefaultEdit>
    );
};
